<template>
  <div class="design">
    <!-- タブ選択 -->
    <div class="design-tab">
      <button
        class="themes"
        :class="{'active':showTabThemes}"
        @click="openTab('Themes')"
      >
        一覧
        <span class="counter">
          {{themeNum.current || '0'}} / {{themeNum.max || '00'}}
        </span>
      </button>
      <button
        class="edit"
        :class="{'active':showTabEdit}"
        @click="openTab('Edit')"
      >
        編集
      </button>
      <div class="underline"></div>
    </div>
    <div class="tab-wrapper">
      <!-- 一覧タブ -->
      <content-design-themes v-if="showTabThemes"/>
      <!-- 編集タブ -->
      <content-design-edit
        v-if="showTabEdit"
        @showDesignDetail="$emit('showDesignDetail', $event)"
        @updateTheme="updateTheme"
        @openTab="openTab"
      />
    </div>
  </div>
</template>

<script>
import ContentDesignThemes from '@/components/Content/Palette/ContentDesign/Themes'
import ContentDesignEdit from '@/components/Content/Palette/ContentDesign/ContentDesignEdit'

export default {
  components: {
    ContentDesignThemes,
    ContentDesignEdit,
  },
  data () {
    return {
      currentTab: 'Themes',
    }
  },
  computed: {
    showTabEdit () {
      return this.currentTab === 'Edit'
    },
    showTabThemes () {
      return this.currentTab === 'Themes'
    },
    themeNum () {
      return this.$store.getters.getThemeNum
    },
  },
  created () {
    this.updateTheme()
  },
  methods: {
    openTab (tab) {
      this.currentTab = tab
    },
    updateTheme () {
      this.$http({
        url: '/theme',
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.$store.commit('updateThemes', json.data.themes)
          this.$store.commit('updateThemeNum', json.data.themeNum)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.design {
  color: $commonFontColor;
  border-top: 1px solid #dbdbdb;
  padding: 10px 20px 0;
  height: calc(100vh - 160px);
  overflow-y: auto;
  .design-tab {
    position: relative;
    button {
      color: #A7A7A7;
      background: #f8f8f8;
      width: 50%;
      height: 40px;
      line-height: 40px;
      border-bottom: #dbdbdb 0.5px solid;
      font-size: 18px;
      cursor: pointer;
      &:focus {
        outline: 0;
      }
      &.active, &:hover {
        color: $commonFontColor;
      }
      &.active {
        ~ .underline {
          width: 50%;
          height: 1.5px;
          background: #707070;
          position: absolute;
          bottom: -0.5px;
          transition: all 0.2s ease-in-out 0s;
        }
      }
      &.themes {
        .counter {
          vertical-align: middle;
          margin-left: 4px;
          font-size: 12px;
          display: inline-block;
          padding: 0 8px;
          line-height: 22px;
          border-radius: 13px;
          background: #e4e4e4;
          // disable状態の時に色が薄くならないように
          color: $commonFontColor;
        }
        &.active {
          ~ .underline {
            left: 0%;
          }
        }
      }
      &.edit.active {
        ~ .underline {
          left: 50%;
        }
      }
    }
  }
  .tab-wrapper {
    margin: 30px 0;
    min-height: calc(100vh - 255px);
  }
}
.modal-inner {
  padding: 20px;
  width: 400px;
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h4 {
    margin: 0 auto;
  }
  input[type=radio] {
    border: 1px solid #999;
  }
  select {
    border: 1px solid #999;
  }
  input {
    border: 1px solid #999;
  }
}
</style>
